import { render, staticRenderFns } from "./addawardgame.vue?vue&type=template&id=2701b60c&scoped=true"
import script from "./addawardgame.vue?vue&type=script&lang=js"
export * from "./addawardgame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701b60c",
  null
  
)

export default component.exports